// Polyfills for older browsers
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';

import Vue from 'vue';

// To reduce the build size, only import the BootstrapVue plugins that we actually use
import {
  AlertPlugin,
  BadgePlugin,
  ButtonPlugin,
  CardPlugin,
  CollapsePlugin,
  FormCheckboxPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  ImagePlugin,
  InputGroupPlugin,
  LayoutPlugin,
  LinkPlugin,
  ListGroupPlugin,
  ModalPlugin,
  NavbarPlugin,
  PaginationPlugin,
  SpinnerPlugin,
  TablePlugin,
  TooltipPlugin,
} from 'bootstrap-vue';

Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(CollapsePlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormFilePlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormPlugin);
Vue.use(FormSelectPlugin);
Vue.use(ImagePlugin);
Vue.use(InputGroupPlugin);
Vue.use(LayoutPlugin);
Vue.use(LinkPlugin);
Vue.use(ListGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);
Vue.use(PaginationPlugin);
Vue.use(SpinnerPlugin);
Vue.use(TablePlugin);
Vue.use(TooltipPlugin);

// Import only the FontAwesome icons that we actually use
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faBuilding,
  faDownload,
  faEdit,
  faExternalLinkAlt,
  faFilter,
  faLock,
  faPlus,
  faSignOutAlt,
  faTrash,
  faUser,
  faUserPlus,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faArrowLeft,
  faBuilding,
  faDownload,
  faEdit,
  faExternalLinkAlt,
  faFilter,
  faLock,
  faPlus,
  faSignOutAlt,
  faTrash,
  faUser,
  faUserPlus,
  faUsers,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

import App from '@/App.vue';
import { Auth0Plugin } from '@/auth0-plugin';
import router from '@/router';

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_CALLBACK_URL,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    history.replaceState({}, document.title, window.location.pathname);
    router.push(
      appState && appState.targetPath
        ? appState.targetPath
        : window.location.pathname,
    );
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

// Disable caching for Axios requests so browsers always get the latest data when making API requests
import axios from 'axios';
// tslint:disable-next-line:no-string-literal
axios.defaults.headers.get['Pragma'] = 'no-cache'; // For HTTP/1 requests
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'; // For HTTP/2 requests

import '@/custom.scss';
